module.exports = __webpack_public_path__ + "static/media/proj19_img2.6ad85312.jpg";